import { render, staticRenderFns } from "./MelosButton.vue?vue&type=template&id=5ac9747c&scoped=true&"
import script from "./MelosButton.vue?vue&type=script&lang=ts&"
export * from "./MelosButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac9747c",
  null
  
)

export default component.exports